// Site copy. The data lives in JSON so it can be edited by anyone — humans,
// scripts, n8n workflows — without touching TypeScript.
// Validated against SiteSchema at module load.
import { SiteSchema, type Site } from '@lib/schemas/site';
import data from './data/site.json';

export const site: Site = SiteSchema.parse(data);
